import { createSelector } from 'reselect';
import { DefaultTask } from './default-task.model';

import {
    handleLoadNextPageAction, handleRehydrateAction,
    handleRemoveAction,
    handleSetFilterAction,
    handleSetTotalAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { PaginatableObjectFilters } from '../../store/bootstrap';
import * as actions from './default-task.actions';

export interface IDefaultTaskFilters extends PaginatableObjectFilters {
    done: boolean;
    sortBy: string;
    sortDirection: number;
    taskType: string;
}

export interface State {
    ids: Array<string>;
    entities: { [id: string]: DefaultTask };
    total: number;
    filters: IDefaultTaskFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    total: 0,
    filters: {
        searchTerm: '',
        done: false,
        sortBy: 'dueDate',
        sortDirection: 0,
        limit: 10,
        offset: 0,
        taskType: ''
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case actions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case actions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case actions.SET_FILTER: {
            return handleSetFilterAction(state, action);
        }
        case actions.SET_TOTAL: {
            return handleSetTotalAction(state, action);
        }
        case actions.LOAD_NEXT_PAGE: {
            return handleLoadNextPageAction(state, action);
        }
        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/default-task/default-task.reducer.ts